/**
 * "Monitoring, cost & audit" — Dashboard section (ADR-0074).
 * Reconciled from apps/web observability, cost, usage-logs, and audit-log features.
 */
import type { DocPageContent } from '../types';

export const DASHBOARD_MONITORING_PAGE: DocPageContent = {
  slug: 'dashboard/monitoring',
  titleKey: 'docs.dashboard.monitoring.title',
  descriptionKey: 'docs.dashboard.monitoring.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.dashboard.monitoring.lead' },

    {
      kind: 'heading',
      level: 2,
      id: 'monitoring',
      textKey: 'docs.dashboard.monitoring.monitor.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.monitoring.monitor.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.monitoring.monitor.item.live',
        'docs.dashboard.monitoring.monitor.item.failed',
        'docs.dashboard.monitoring.monitor.item.coverage',
        'docs.dashboard.monitoring.monitor.item.feedback',
      ],
    },

    { kind: 'heading', level: 2, id: 'cost', textKey: 'docs.dashboard.monitoring.cost.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.monitoring.cost.body' },

    { kind: 'heading', level: 2, id: 'usage', textKey: 'docs.dashboard.monitoring.usage.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.monitoring.usage.body' },

    { kind: 'heading', level: 2, id: 'audit', textKey: 'docs.dashboard.monitoring.audit.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.monitoring.audit.body' },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.dashboard.monitoring.next.environments.title',
          textKey: 'docs.dashboard.monitoring.next.environments.text',
          to: { docSlug: 'dashboard/environments' },
        },
        {
          titleKey: 'docs.dashboard.monitoring.next.reliability.title',
          textKey: 'docs.dashboard.monitoring.next.reliability.text',
          to: { docSlug: 'reliability' },
        },
      ],
    },
  ],
};
